var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.339,
    height: 97.339,
    viewBox: "0 0 97.339 97.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5547",
    "data-name": "Group 5547",
    transform: "translate(-719 -1993)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 48.669,
    cy: 48.669,
    r: 48.669,
    transform: "translate(719 1993)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "project-icon",
    transform: "translate(749.357 2021.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M12.828,26.214a.992.992,0,0,1,0-1.953H17.31a.992.992,0,0,1,0,1.953Zm15.34-4.048a9.116,9.116,0,1,1-6.448,2.67,9.088,9.088,0,0,1,6.448-2.67Zm-.7,4.854a.815.815,0,0,1,1.631,0v4.248l3.176,1.881a.814.814,0,0,1-.829,1.4l-3.535-2.095a.814.814,0,0,1-.444-.727V27.02Zm5.995-1.029a7.494,7.494,0,1,0,2.193,5.3,7.471,7.471,0,0,0-2.193-5.3ZM14.5,36.152a.977.977,0,0,1,0,1.953H2.276A2.279,2.279,0,0,1,0,35.833V2.276A2.279,2.279,0,0,1,2.276,0H30.193a2.279,2.279,0,0,1,2.276,2.276V17.823a.977.977,0,1,1-1.953,0V2.276a.326.326,0,0,0-.319-.319H2.276a.311.311,0,0,0-.224.1.3.3,0,0,0-.1.224V35.833a.311.311,0,0,0,.1.224.316.316,0,0,0,.224.1ZM6.287,23.837h2.45a.323.323,0,0,1,.322.322v2.45a.323.323,0,0,1-.322.322H6.287a.323.323,0,0,1-.322-.322v-2.45a.325.325,0,0,1,.322-.322Zm0-16.77h2.45a.323.323,0,0,1,.322.322v2.45a.323.323,0,0,1-.322.322H6.287a.323.323,0,0,1-.322-.322V7.389a.327.327,0,0,1,.322-.322Zm6.54,2.377a.907.907,0,0,1-.819-.977.909.909,0,0,1,.819-.977h11.66a.907.907,0,0,1,.819.977.909.909,0,0,1-.819.977ZM7.29,18.461a.548.548,0,0,1-.727-.082.552.552,0,0,1-.069-.059L5.468,17.26a.575.575,0,0,1,.112-.832.662.662,0,0,1,.891-.026l.559.575,1.8-1.447a.575.575,0,0,1,.819.187.662.662,0,0,1-.056.888l-2.3,1.855Zm5-.819a.992.992,0,0,1,0-1.953h11.66a.992.992,0,0,1,0,1.953Z",
    fill: "#ff5d00",
    stroke: "#ff5d00",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalball);
export default __webpack_public_path__ + "static/media/calball.3822df79d21d600bfc03401e85cdff57.svg";
export { ForwardRef as ReactComponent };